<template>
  <div class="JoinUs"
       ref="JoinUs">
    <JoinGpu1  />
  </div>
</template>

<script>
// @ is an alias to /src
import JoinGpu1 from "@/components/JoinGpu1.vue";
export default {
  name: "JoinUs",
  data () {
    return {
      flag: false
    };
  },

  components: {
    JoinGpu1,
  }
};
</script>
<style>
.transition-box {
  margin-bottom: 10px;
  width: 200px;
  height: 100px;
  border-radius: 4px;
  background-color: #409eff;
  text-align: center;
  color: #fff;
  padding: 40px 20px;
  box-sizing: border-box;
  margin-right: 20px;
}
</style>
